import {FullCalendarModule} from '@fullcalendar/angular'; // must go before plugins

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FullCalendarComponent} from './full-calendar/full-calendar.component';
import {FilterButtonComponent} from './full-calendar/filter-button/filter-button.component';
import {TypesFilterComponent} from './full-calendar/filter-button/types-filter/types-filter.component';
import {UsersFilterComponent} from './full-calendar/filter-button/users-filter/users-filter.component';
import {EventTipComponent} from './full-calendar/event-tip/event-tip.component';
import {UserScheduleComponent} from './user-schedule/user-schedule.component';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {DesktopProjectModule} from '../project/desktop-project.module';

import {CheckboxModule} from 'primeng/checkbox';
import {MultiSelectModule} from 'primeng/multiselect';
import {ButtonModule} from 'primeng/button';
import {CoreModule, MiscModule} from 'projects/core/src/public-api';
import {MatButtonModule} from '@angular/material/button';
import {MatRippleModule} from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogModule} from '@angular/material/dialog';
import {TooltipModule} from 'primeng/tooltip';
import {WidgetBarModule} from '../../../../../mobile/src/app/modules/widget-bar/widget-bar.module';
import {ConfirmDialogModule} from 'primeng/confirmdialog';


@NgModule({
  declarations: [
    FullCalendarComponent,
    FilterButtonComponent,
    TypesFilterComponent,
    UsersFilterComponent,
    EventTipComponent,
    UserScheduleComponent
  ],
  imports: [
    FullCalendarModule,
    CommonModule,
    CoreModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    MatButtonModule,
    MatRippleModule,
    MatIconModule,
    MatDialogModule,
    TooltipModule,
    OverlayPanelModule,
    CheckboxModule,
    MultiSelectModule,
    MiscModule,
    DesktopProjectModule,
    WidgetBarModule,
    ConfirmDialogModule
  ],
  exports: [
    FullCalendarComponent,
    FilterButtonComponent,
    TypesFilterComponent,
    UsersFilterComponent,
    EventTipComponent,
    UserScheduleComponent
  ],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ACCalendarModule {
}
